import React from 'react'
import { FORM_ERROR } from 'final-form'
import { trackError } from '@mc/monitoring'
import { trackEmailCaptured } from '@mc/pre-paywall-events'
import { segment, track } from '@mc/track-event'
import {
  signUp,
  redirect,
  fbAuth,
  isSuccessful,
  needsConfirmation,
} from '../../services'
import { isGiftAccountClarificationOn } from '../../utils'
import GiftRegisterForm from './GiftRegisterForm'
import RegisterForm from './RegisterForm'

const RegisterFormContainer = (props) => {
  const handleSubmit = async (values) => {
    const { nextPage, afterAuthAction, onLogIn } = props
    try {
      track(segment.EventTypes.SIGN_UP_MODAL_CTA_CLICKED, {
        signup_method: 'email',
      })
      const res = await signUp({ ...values, nextPage })

      try {
        await trackEmailCaptured({
          event: 'Email Captured',
          properties: {
            email: values.email,
            marketing_consent: !!values.gdprOptIn,
            location: 'sign up modal',
          },
        })
      } catch (e) {
        // Don't block the auth flow — report to New Relic.
        trackError(
          e instanceof Error ? e : new Error('trackEmailCaptured failed'),
          {
            location: 'RegisterFormContainer',
          },
        )
      }

      if (afterAuthAction) {
        afterAuthAction(res)
      }
      redirect(res, onLogIn)
      return {}
    } catch (error) {
      if (error.email) {
        return { [FORM_ERROR]: 'That email has already been taken' }
      } else if (error.password) {
        return { [FORM_ERROR]: `Password ${error.password[0]}` }
      }
      return { [FORM_ERROR]: error }
    }
  }

  const handleFacebookResponse = (res) => {
    const { onLogIn, afterAuthAction, onConfirmationRequired } = props
    if (isSuccessful(res)) {
      if (afterAuthAction) {
        afterAuthAction(res, 'facebook')
      }

      redirect(res, onLogIn)
    } else if (needsConfirmation(res)) {
      onConfirmationRequired(res)
    }
  }

  const facebookSignUp = async () => {
    try {
      const res = await fbAuth()
      handleFacebookResponse(res)
      return {}
    } catch (error) {
      return { [FORM_ERROR]: error }
    }
  }

  return isGiftAccountClarificationOn() ? (
    <GiftRegisterForm
      onSubmit={handleSubmit}
      facebookSignUp={facebookSignUp}
      {...props}
    />
  ) : (
    <RegisterForm
      onSubmit={handleSubmit}
      facebookSignUp={facebookSignUp}
      {...props}
    />
  )
}
export default RegisterFormContainer
